var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2188 7.40625V0.5625H34.7812V7.40625H30.2188ZM43.0714 9.62775L46.4933 3.70089L50.4445 5.98214L47.0226 11.909L43.0714 9.62775ZM32.5 48.4688C41.3193 48.4688 48.4688 41.3193 48.4688 32.5C48.4688 23.6807 41.3193 16.5312 32.5 16.5312C23.6807 16.5312 16.5312 23.6807 16.5312 32.5C16.5312 41.3193 23.6807 48.4688 32.5 48.4688ZM32.5 53.0312C43.8391 53.0312 53.0312 43.8391 53.0312 32.5C53.0312 21.1609 43.8391 11.9688 32.5 11.9688C21.1609 11.9688 11.9688 21.1609 11.9688 32.5C11.9688 43.8391 21.1609 53.0312 32.5 53.0312ZM57.5938 30.2188H64.4375V34.7812H57.5938V30.2188ZM59.018 14.5556L53.0911 17.9775L55.3724 21.9287L61.2992 18.5069L59.018 14.5556ZM14.5556 5.98214L17.9775 11.909L21.9287 9.62775L18.5069 3.70089L14.5556 5.98214ZM9.62761 21.9287L3.70075 18.5069L5.982 14.5556L11.9089 17.9775L9.62761 21.9287ZM30.2188 57.5938V64.4375H34.7812V57.5938H30.2188ZM7.40625 30.2188H0.5625V34.7812H7.40625V30.2188ZM3.70063 46.4931L9.62749 43.0713L11.9087 47.0225L5.98188 50.4444L3.70063 46.4931ZM17.9776 53.0914L14.5558 59.0183L18.507 61.2995L21.9289 55.3727L17.9776 53.0914ZM46.4931 61.2995L43.0713 55.3727L47.0225 53.0914L50.4444 59.0183L46.4931 61.2995ZM53.0913 47.0225L59.0181 50.4444L61.2994 46.4931L55.3725 43.0713L53.0913 47.0225Z",
    fill: "#FFAE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.fb3fa280c1a03a21535e2e20347e820a.svg";
export { ForwardRef as ReactComponent };